<template>
  <div class='projectTag'>{{projectTypeName}}</div>
</template>
<script>
import { mapState } from "vuex";
export default {
  computed: {
    ...mapState({
      projectTypeName: state => state.homeProject.projectTypeName
    })
  }
}
</script>
<style lang="scss" scoped>
.projectTag {
  background: url('http://yiyang.oss-cn-beijing.aliyuncs.com/WEB/img/tag.png')
    no-repeat;
  min-width: 160px;
  padding: 0 30px;
  background-size: cover;
  height: 30px;
  color: #fff;
  line-height: 30px;
  position: absolute;
  top: 0;
  right: 37px;
}
</style>